import { InputAdornment, TextField, Typography, alpha, useTheme } from '@mui/material';
import SaveButton from '../../SaveButton';

interface EditableContentProps {
    isEditing: boolean;
    text: string;
    editText: string;
    completed: boolean;
    inputRef: React.RefObject<HTMLInputElement>;
    onTextChange: (text: string) => void;
    onKeyPress: (e: React.KeyboardEvent) => void;
    onSave: () => void;
}

export const EditableContent: React.FC<EditableContentProps> = ({
    isEditing,
    text,
    editText,
    completed,
    inputRef,
    onTextChange,
    onKeyPress,
    onSave
}) => {
    const theme = useTheme();

    if (isEditing) {
        return (
            <TextField
                inputRef={inputRef}
                autoFocus
                multiline
                value={editText}
                onChange={(e) => onTextChange(e.target.value)}
                onKeyDown={onKeyPress}
                onBlur={onSave}
                variant="standard"
                size="small"
                fullWidth
                sx={{
                    '& .MuiInput-root': {
                        p: 0.05,
                        '&:before, &:after': {
                            borderColor: theme => alpha(theme.palette.common.black, 0.5),
                            // borderBottom: 'none',
                        },
                        '&:hover:not(.Mui-disabled):before': {
                            // borderBottom: 'none',
                        },
                    },
                    '& .MuiInputBase-input': {
                        p: 0,
                        '&::selection': {
                            background: 'rgba(255, 255, 255, 0.2)',
                        },
                        fontSize: theme.typography.caption.fontSize,
                        lineHeight: theme.typography.caption.lineHeight,
                    },
                    '& .MuiInput-underline': {
                        // borderBottomStyle: 'none',
                    },
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <SaveButton
                                disabled={editText.length === 0}
                                onSave={onSave}
                            />
                        </InputAdornment>
                    ),
                }}
            />
        );
    }

    return (
        <Typography
            variant="caption"
            sx={{
                flex: 1,
                textDecoration: completed ? 'line-through' : 'none',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
                [theme.breakpoints.down('sm')]: {
                    fontSize: '0.6rem',
                },
            }}
        >
            {text}
        </Typography>
    );
}; 